/**
 * User's permits
 */
export const GET_USER_PERMITS_REQUEST = "GET_PERMITS_REQUEST";
export const GET_USER_PERMITS_SUCCESS = "GET_PERMITS_SUCCESS";
export const GET_USER_PERMITS_ERROR = "GET_PERMITS_ERROR";

/**
 * Permit limits
 */
export const GET_PERMIT_LIMITS_REQUEST = "GET_PERMIT_LIMITS_REQUEST";
export const GET_PERMIT_LIMITS_SUCCESS = "GET_PERMIT_LIMITS_SUCCESS";
export const GET_PERMIT_LIMITS_ERROR = "GET_PERMIT_LIMITS_ERROR";

/**
 * Permit details
 */
export const GET_PERMIT_TYPE_DETAILS_REQUEST = "GET_PERMIT_TYPE_DETAILS_REQUEST";
export const GET_PERMIT_TYPE_DETAILS_SUCCESS = "GET_PERMIT_TYPE_DETAILS_SUCCESS";
export const GET_PERMIT_TYPE_DETAILS_ERROR = "GET_PERMIT_TYPE_DETALS_ERROR";

/**
 * User's active applications
 */
export const GET_USER_APPLICATIONS_ERROR = "GET_APPLICATIONS_ERROR";
export const GET_USER_APPLICATIONS_REQUEST = "GET_APPLICATIONS_REQUEST";
export const GET_USER_APPLICATIONS_SUCCESS = "GET_APPLICATIONS_SUCCESS";
export const REMOVE_USER_APPLICATION_FROM_LIST = "REMOVE_USER_APPLICATION_FROM_LIST";

/**
 * Single user application
 */
export const GET_SINGLE_USER_APPLICATION_REQUEST = "GET_SINGLE_USER_APPLICATION_REQUEST";
export const GET_SINGLE_USER_APPLICATION_SUCCESS = "GET_SINGLE_USER_APPLICATION_SUCCESS";
export const GET_SINGLE_USER_APPLICATION_ERROR = "GET_SINGLE_USER_APPLICATION_ERROR";

/**
 * Permit Type
 */
export const SET_ACTIVE_PERMIT_TYPE_DETAILS = "SET_ACTIVE_PERMIT_TYPE_DETAILS";
export const SET_ACTIVE_PERMIT_TYPE_DEFAULT_VALUES = "SET_ACTIVE_PERMIT_TYPE_DEFAULT_VALUES";

/**
 * User's permits
 */
export const GET_USER_CITATIONS_REQUEST = "GET_CITATIONS_REQUEST";
export const GET_USER_CITATIONS_SUCCESS = "GET_CITATIONS_SUCCESS";
export const RESET_USER_CITATIONS = "RESET_USER_CITATIONS";
export const GET_USER_CITATIONS_ERROR = "GET_CITATIONS_ERROR";

/**
 * Cart
 */
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CHANGE_CART_DRAWER = "CHANGE_CART_DRAWER";
export const REPLACE_ITEM_IN_CART = "REPLACE_ITEM_IN_CART";

/**
 * Documents
 */
export const LOAD_DOCUMENTS = "LOAD_DOCUMENTS";
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";
export const REMOVE_DOCUMENT = "REMOVE_DOCUMENT";

/**
 * Application
 */
export const SAVE_APPLICATION_REQUEST = "SAVE_APPLICATION_REQUEST";
export const SAVE_APPLICATION_ERROR = "SAVE_APPLICATION_ERROR";
export const REMOVE_USER_APPLICATION = "REMOVE_USER_APPLICATION";
export const UPDATE_APPLICATION_REQUEST = "UPDATE_APPLICATION_REQUEST";
export const UPDATE_APPLICATION_REQUEST_ERROR = "UPDATE_APPLICATION_REQUEST_ERROR";
/**
 * Split write/quote application actions (F2.1 serialized-write contract).
 * The write settles the thunk and merges the application into redux (retaining
 * the prior quote-derived rate); the background quote of the LATEST write
 * generation lands separately and merges the rate onto savedApplication and
 * primes the react-query display cache (product_totals/quoteItems live there,
 * not redux - F3.1). A quote failure is non-fatal and routes to the
 * *_QUOTE_ERROR action, never the fatal write-error path.
 */
export const SAVE_APPLICATION_WRITE_SUCCESS = "SAVE_APPLICATION_WRITE_SUCCESS";
export const SAVE_APPLICATION_QUOTE_SUCCESS = "SAVE_APPLICATION_QUOTE_SUCCESS";
export const SAVE_APPLICATION_QUOTE_ERROR = "SAVE_APPLICATION_QUOTE_ERROR";
export const UPDATE_APPLICATION_WRITE_SUCCESS = "UPDATE_APPLICATION_WRITE_SUCCESS";
// Application-id-gated "a re-quote is coming" marker, dispatched at WRITE START for
// rate-affecting updates so the price slot enters its refreshing state for the whole
// write+quote window (not just the quote leg). It reuses the existing isQuoteUpdating
// flag; the quote success/error still clears it under the existing generation + id gating.
export const UPDATE_APPLICATION_QUOTE_START = "UPDATE_APPLICATION_QUOTE_START";
export const UPDATE_APPLICATION_QUOTE_SUCCESS = "UPDATE_APPLICATION_QUOTE_SUCCESS";
export const UPDATE_APPLICATION_QUOTE_ERROR = "UPDATE_APPLICATION_QUOTE_ERROR";
export const GET_SINGLE_USER_APPLICATION_QUOTE_SUCCESS = "GET_SINGLE_USER_APPLICATION_QUOTE_SUCCESS";
export const GET_SINGLE_USER_APPLICATION_QUOTE_ERROR = "GET_SINGLE_USER_APPLICATION_QUOTE_ERROR";
/**
 * Application Steps
 */
export const STEP_SUBMIT = "STEP_SUBMIT";
export const STEP_CONTINUE = "STEP_CONTINUE";

/**
 * Addresses
 */
export const GET_OPERATOR_ADDRESSES_ERROR = "GET_OPERATOR_ADDRESSES_ERROR";
export const GET_OPERATOR_ADDRESSES_REQUEST = "GET_OPERATOR_ADDRESSES_REQUEST";
export const GET_OPERATOR_ADDRESSES_SUCCESS = "GET_OPERATOR_ADDRESSES_SUCCESS";

/**
 * Settings
 */
export const GET_OPERATOR_SETTINGS_ERROR = "GET_OPERATOR_SETTINGS_ERROR";
export const GET_OPERATOR_SETTINGS_REQUEST = "GET_OPERATOR_SETTINGS_REQUEST";
export const GET_OPERATOR_SETTINGS_SUCCESS = "GET_OPERATOR_SETTINGS_SUCCESS";

/**
 * User Permit
 */
export const RESET_USER_PERMIT = "RESET_USER_PERMIT";
export const GET_SINGLE_PERMIT_ERROR = "GET_SINGLE_PERMIT_ERROR";
export const UPDATE_SINGLE_USER_PERMIT = "UPDATE_SINGLE_USER_PERMIT";
export const GET_SINGLE_PERMIT_REQUEST = "GET_SINGLE_PERMIT_REQUEST";
export const GET_SINGLE_PERMIT_SUCCESS = "GET_SINGLE_PERMIT_SUCCESS";
export const UPDATE_SINGLE_PERMIT_ERROR = "UPDATE_SINGLE_PERMIT_ERROR";
export const UPDATE_SINGLE_PERMIT_REQUEST = "UPDATE_SINGLE_PERMIT_REQUEST";
export const UPDATE_SINGLE_PERMIT_SUCCESS = "UPDATE_SINGLE_PERMIT_SUCCESS";
export const UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_ERROR = "UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_ERROR";
export const UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_REQUEST = "UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_REQUEST";
export const UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_SUCCESS = "UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_SUCCESS";
export const ADD_SINGLE_PERMIT_VEHICLE_ERROR = "ADD_SINGLE_PERMIT_VEHICLE_ERROR";
export const ADD_SINGLE_PERMIT_VEHICLE_REQUEST = "ADD_SINGLE_PERMIT_VEHICLE_REQUEST";
export const ADD_SINGLE_PERMIT_VEHICLE_SUCCESS = "ADD_SINGLE_PERMIT_VEHICLE_SUCCESS";
export const UPDATE_SINGLE_PERMIT_VEHICLE_ERROR = "UPDATE_SINGLE_PERMIT_VEHICLE_ERROR";
export const UPDATE_SINGLE_PERMIT_VEHICLE_REQUEST = "UPDATE_SINGLE_PERMIT_VEHICLE_REQUEST";
export const UPDATE_SINGLE_PERMIT_VEHICLE_SUCCESS = "UPDATE_SINGLE_PERMIT_VEHICLE_SUCCESS";
export const REMOVE_SINGLE_PERMIT_VEHICLE_ERROR = "REMOVE_SINGLE_PERMIT_VEHICLE_ERROR";
export const REMOVE_SINGLE_PERMIT_VEHICLE_REQUEST = "REMOVE_SINGLE_PERMIT_VEHICLE_REQUEST";
export const REMOVE_SINGLE_PERMIT_VEHICLE_SUCCESS = "REMOVE_SINGLE_PERMIT_VEHICLE_SUCCESS";

/**
 * Permit Change Requests
 */
export const SET_PERMIT_CHANGE_REQUEST = "ADD_PERMIT_CHANGE_REQUEST";
export const REMOVE_PERMIT_CHANGE_REQUEST = "REMOVE_PERMIT_CHANGE_REQEST";
